import { action, createRequestTypes } from './base';

export const sellerActionTypes = {
  GET_CITY_STATE: 'GET_CITY_STATE',
  CREATE_SELLER: createRequestTypes('CREATE_SELLER'),
  GET_SELLER_BY_ID: createRequestTypes('GET_SELLER_BY_ID'),
  GET_SELLERS: createRequestTypes('GET_SELLERS'),
  SEARCH_SELLERS: createRequestTypes('SEARCH_SELLERS'),
  UPDATE_SELLER: createRequestTypes('UPDATE_SELLER'),
  UPDATE_SELLER_OFFERS: createRequestTypes('UPDATE_SELLER_OFFERS'),
  DELETE_SELLER: createRequestTypes('DELETE_SELLER'),
  GET_SELLER_OFFERS_BY_ID: createRequestTypes('GET_SELLER_OFFERS_BY_ID'),
  GET_ORG_SELLERS: createRequestTypes('GET_ORG_SELLERS'),
  GET_SELLER_REPORTS: createRequestTypes('GET_SELLER_REPORTS'),
  GET_SELLER_DOWNLOAD_REPORTS: createRequestTypes('GET_SELLER_DOWNLOAD_REPORTS'),
  SEND_ACCOUNT_STATEMENT_MAIL: createRequestTypes('SEND_ACCOUNT_STATEMENT_MAIL'),
  LINK_CUSTOMER: createRequestTypes('LINK_CUSTOMER'),
  GET_BULK_UPLOAD_SELLER_META_DATA: createRequestTypes('GET_BULK_UPLOAD_SELLER_META_DATA'),
  BULK_UPLOAD_SELLER: createRequestTypes('BULK_UPLOAD_SELLER'),
  BULK_UPDATE_SELLER: createRequestTypes('BULK_UPDATE_SELLER'),
  GET_TALLY_SELLERS: createRequestTypes('GET_TALLY_SELLERS'),
};

/**
 *
 */
class SellerActions {
  /**
   *
   * @param pincode
   * @return {{pincode: *, type: string}}
   */
  getCityState(pincode) {
    return {
      type: sellerActionTypes.GET_CITY_STATE,
      pincode,
    };
  }

  /**
   *
   * @param cityStateLoading
   * @return {{cityStateLoading: *, type: string}}
   */
  getCityStateLoading(cityStateLoading) {
    return {
      type: `${sellerActionTypes.GET_CITY_STATE}_LOADING`,
      cityStateLoading,
    };
  }

  /**
   *
   * @param pincodeCity
   * @param pincodeState
   * @return {{pincodeState: *, type: string, pincodeCity: *}}
   */
  setCityState(pincodeCity, pincodeState) {
    return {
      type: `${sellerActionTypes.GET_CITY_STATE}_SUCCESS`,
      pincodeCity,
      pincodeState,
      setCityStateError: null,
    };
  }

  /**
   * @param payload
   * @param callback
   * @return {{type: *}}
   */
  createSeller = (payload, callback) => action(sellerActionTypes.CREATE_SELLER.REQUEST, {
    payload,
    callback,
  });

  /**
   *
   * @param createSellerLoading
   * @return {{type: *}}
   */
  createSellerLoading = (createSellerLoading) => action(sellerActionTypes.CREATE_SELLER.LOADING, {
    createSellerLoading,
  })

  /**
   *
   * @param createdSeller
   * @return {{type: *}}
   */
  createSellerSuccess = (createdSeller) => action(sellerActionTypes.CREATE_SELLER.SUCCESS, {
    createdSeller,
  })

  /**
   * @param page
   * @param keyword
   * @param orgId
   * @param limit
   * @param sellerId
   * @param tenantSellerId
   * @param callback
   * @param isActive
   * @param tenantId
   * @return {{type: *}}
   */
  getSellers = (keyword, tenantId, page, limit, sellerId, callback, isActive, isSubcontractor, sellerType, isMarketplaceSeller, selectedSellerIds, excludeSellerIds, advanceFilters) => action(sellerActionTypes.GET_SELLERS.REQUEST, {
    keyword,
    tenantId,
    page,
    limit,
    sellerId,
    callback,
    isActive,
    isSubcontractor,
    sellerType,
    isMarketplaceSeller,
    selectedSellerIds,
    excludeSellerIds,
    advanceFilters
  });

  /**
   *
   * @param getSellersLoading
   * @return {{type: *}}
   */
  getSellersLoading = (getSellersLoading) => action(sellerActionTypes.GET_SELLERS.LOADING, {
    getSellersLoading,
  })

  /**
   *
   * @param sellers
   * @return {{type: *}}
   */
  getSellersSuccess = (sellers) => action(sellerActionTypes.GET_SELLERS.SUCCESS, {
    sellers,
  })

  // searchSellersName
  searchSellersName = (keyword, tenantId, page, limit, sellerId, callback, isActive, isSubcontractor, sellerType) => action(sellerActionTypes.SEARCH_SELLERS.REQUEST, {
    keyword,
    tenantId,
    page,
    limit,
    sellerId,
    callback,
    isActive,
    isSubcontractor,
    sellerType,
  });

  /**
   *
   * @param getSellersLoading
   * @return {{type: *}}
   */
  searchSellersNameLoading = (searchSellersNameLoading) => action(sellerActionTypes.SEARCH_SELLERS.LOADING, {
    searchSellersNameLoading,
  })

  /**
   *
   * @param sellers
   * @return {{type: *}}
   */
  searchSellersNameSuccess = (searchSellersNameResults) => action(sellerActionTypes.SEARCH_SELLERS.SUCCESS, {
    searchSellersNameResults,
  })

  /**
   * @param sellerId
   * @param tenantId
   * @return {{type: *}}
   */
  getSellerById = (sellerId, tenantId) => action(sellerActionTypes.GET_SELLER_BY_ID.REQUEST, {
    sellerId,
    tenantId,
  })

  /**
   *
   * @param getSellerByIdLoading
   * @return {{type: *}}
   */
  getSellerByIdLoading = (getSellerByIdLoading) => action(sellerActionTypes.GET_SELLER_BY_ID.LOADING, {
    getSellerByIdLoading,
  });

  /**
   *
   * @param selectedSeller
   * @return {{type: *}}
   */
  getSellerByIdSuccess = (selectedSeller) => action(sellerActionTypes.GET_SELLER_BY_ID.SUCCESS, {
    selectedSeller,
  });

  /**
   * @param sellerid
   * @param page
   * @param sellerId
   * @return {{type: *}}
   */
  getSellerOffersById = (sellerid, page) => action(sellerActionTypes.GET_SELLER_OFFERS_BY_ID.REQUEST, {
    sellerid,
    page,
  })

  /**
   *
   * @param getSellerOffersByIdLoading
   * @return {{type: *}}
   */
  getSellerOffersByIdLoading = (getSellerOffersByIdLoading) => action(sellerActionTypes.GET_SELLER_OFFERS_BY_ID.LOADING, {
    getSellerOffersByIdLoading,
  });

  /**
   * @param selectedSellerOffers
   * @param selectedSeller
   * @return {{type: *}}
   */
  getSellerOffersByIdSuccess = (selectedSellerOffers) => action(sellerActionTypes.GET_SELLER_OFFERS_BY_ID.SUCCESS, {
    selectedSellerOffers,
  });

  /**
   * @param payload
   * @param callback
   * @param history
   * @return {{type: *}}
   */
  updateSeller = (payload, callback) => action(sellerActionTypes.UPDATE_SELLER.REQUEST, {
    payload,
    callback,
  });

  /**
   *
   * @param updateSellerLoading
   * @return {{type: *}}
   */
  updateSellerLoading = (updateSellerLoading) => action(sellerActionTypes.UPDATE_SELLER.LOADING, {
    updateSellerLoading,
  })

  /**
   *
   * @param updatedSeller
   * @return {{type: *}}
   */
  updateSellerSuccess = (updatedSeller) => action(sellerActionTypes.UPDATE_SELLER.SUCCESS, {
    updatedSeller,
  })

  /**
   * @param payload
   * @param callback
   * @param page
   * @return {{type: *}}
   */
  updateSellerOffers = (payload, callback) => action(sellerActionTypes.UPDATE_SELLER_OFFERS.REQUEST, {
    payload,
    callback,
  });

  /**
   *
   * @param updateSellerOffersLoading
   * @return {{type: *}}
   */
  updateSellerOffersLoading = (updateSellerOffersLoading) => action(sellerActionTypes.UPDATE_SELLER_OFFERS.LOADING, {
    updateSellerOffersLoading,
  })

  /**
   * @param updatedSellerOffers
   * @param updatedSeller
   * @return {{type: *}}
   */
  updateSellerOffersSuccess = (updatedSellerOffers) => action(sellerActionTypes.UPDATE_SELLER_OFFERS.SUCCESS, {
    updatedSellerOffers,
  })

  /**
   * @param sellerId
   * @param currentPage
   * @return {{type: *}}
   */
  deleteSeller = (sellerId, currentPage) => action(sellerActionTypes.DELETE_SELLER.REQUEST, {
    sellerId,
    currentPage,
  })

  /**
   *
   * @param deleteSellerLoading
   * @return {{type: *}}
   */
  deleteSellerLoading = (deleteSellerLoading) => action(sellerActionTypes.DELETE_SELLER.LOADING, {
    deleteSellerLoading,
  });

  /**
   *
   * @param deletedSeller
   * @return {{type: *}}
   */
  deleteSellerSuccess = (deletedSeller) => action(sellerActionTypes.DELETE_SELLER.SUCCESS, {
    deletedSeller,
  });

  /**
   * @param orgId
   * @param sellerId
   * @param tenantId
   * @param page
   * @param limit
   * @param sellerName
   * @return {{type: *}}
   */
  getOrgSellers = (orgId, sellerId, tenantId, page, limit, sellerName, isVendorArchive) => action(sellerActionTypes.GET_ORG_SELLERS.REQUEST, {
    orgId, sellerId, tenantId, page, limit, sellerName, isVendorArchive,
  })

  /**
   *
   * @param getOrgSellersLoading
   * @return {{type: *}}
   */
  getOrgSellersLoading = (getOrgSellersLoading) => action(sellerActionTypes.GET_ORG_SELLERS.LOADING, {
    getOrgSellersLoading,
  })

  /**
   *
   * @param orgSellers
   * @return {{type: *}}
   */
  getOrgSellersSuccess = (orgSellers) => action(sellerActionTypes.GET_ORG_SELLERS.SUCCESS, {
    orgSellers,
  })

  /**
  * @param orgId
  * @param tenantIds
  * @param fromDate
  * @param toDate
  * @param firstSubUrl
  * @param secondSubUrl
  * @param reportType
  * @param sellerId
  * @return
  */
  getReports = (firstSubUrl, secondSubUrl, tenantId, tenantSellerId, fromDate, toDate, customerId) => action(sellerActionTypes.GET_SELLER_REPORTS.REQUEST, {
    firstSubUrl, secondSubUrl, tenantId, tenantSellerId, fromDate, toDate, customerId,
  })

  /**
   *
   * @param {*} getReportsLoading
   * @return
   */
  getReportsLoading = (getReportsLoading) => action(sellerActionTypes.GET_SELLER_REPORTS.LOADING, {
    getReportsLoading,
  })

  /**
   *
   * @param {*} reportData
   * @return
   */
  getReportsSuccess = (reportData) => action(sellerActionTypes.GET_SELLER_REPORTS.SUCCESS, {
    reportData,
  })

  /**
   * @param {*} firstSubUrl
   * @param {*} secondSubUrl
   * @param {*} orgId
   * @param {*} tenantIds
   * @param {*} fromDate
   * @param {*} toDate
   * @param fileReportType
   * @param reportName
   * @param {*} type
   * @param {*} sellerId
   * @return
   */
  getDownloadReports = (firstSubUrl, secondSubUrl, tenantId, tenantSellerId, fromDate, toDate, fileReportType) => action(sellerActionTypes.GET_SELLER_DOWNLOAD_REPORTS.REQUEST, {
    firstSubUrl, secondSubUrl, tenantId, tenantSellerId, fromDate, toDate, fileReportType,
  })

  /**
   *
   * @param {*} getDownloadReportsLoading
   * @return
   */
  getDownloadReportsLoading = (getDownloadReportsLoading) => action(sellerActionTypes.GET_SELLER_DOWNLOAD_REPORTS.LOADING, {
    getDownloadReportsLoading,
  })

  /**
   *
   * @param {*} downloadReportsData
   * @return
   */
  getDownloadReportsSuccess = (downloadReportsData) => action(sellerActionTypes.GET_SELLER_DOWNLOAD_REPORTS.SUCCESS, {
    downloadReportsData,
  })

  /**
 * @param payload
 * @param callback
 * @return {{type: *}}
 */
  sendAccountStatementMail = (payload, callback) => action(sellerActionTypes.SEND_ACCOUNT_STATEMENT_MAIL.REQUEST, {
    payload,
    callback,
  });

  /**
   *
   * @param sendAccountStatementMailLoading
   * @return {{type: *}}
   */
  sendAccountStatementMailLoading = (sendAccountStatementMailLoading) => action(sellerActionTypes.SEND_ACCOUNT_STATEMENT_MAIL.LOADING, {
    sendAccountStatementMailLoading,
  })

  /**
   *
   * @param payload
   * @param callback
   * @returns {{type: *}}
   */
  linkCustomer = (payload, callback) => action(sellerActionTypes.LINK_CUSTOMER.REQUEST, {
    payload, callback,
  })

  /**
   *
   * @param linkCustomerLoading
   * @returns {{type: *}}
   */
  linkCustomerLoading = (linkCustomerLoading) => action(sellerActionTypes.LINK_CUSTOMER.LOADING, {
    linkCustomerLoading,
  })

  /**
   *
   * @returns {{type: *}}
   */
  getBulkUploadSellerMetadata = () => action(sellerActionTypes.GET_BULK_UPLOAD_SELLER_META_DATA.REQUEST, {})

  /**
   *
   * @param getBulkUploadSellerMetadataLoading
   * @returns {{type: *}}
   */
  getBulkUploadSellerMetadataLoading = (getBulkUploadSellerMetadataLoading) => action(sellerActionTypes.GET_BULK_UPLOAD_SELLER_META_DATA.LOADING, {
    getBulkUploadSellerMetadataLoading,
  })

  /**
   *
   * @param bulkUploadSellerMetadata
   * @returns {{type: *}}
   */
  getBulkUploadSellerMetadataSuccess = (bulkUploadSellerMetadata) => action(sellerActionTypes.GET_BULK_UPLOAD_SELLER_META_DATA.SUCCESS, {
    bulkUploadSellerMetadata,
  })

  /**
   *
   * @param payload
   * @param callback
   * @returns {{type: *}}
   */
  bulkUploadSellers = (payload, callback) => action(sellerActionTypes.BULK_UPLOAD_SELLER.REQUEST, {
    payload, callback,
  })

  /**
   *
   * @param bulkUploadSellersLoading
   * @returns {{type: *}}
   */
  bulkUploadSellersLoading = (bulkUploadSellersLoading) => action(sellerActionTypes.BULK_UPLOAD_SELLER.LOADING, {
    bulkUploadSellersLoading,
  })

  /**
   *
   * @param bulkUploadResponse
   * @returns {{type: *}}
   */
  bulkUploadSellersSuccess = (bulkUploadResponse) => action(sellerActionTypes.BULK_UPLOAD_SELLER.SUCCESS, {
    bulkUploadResponse,
  })

  /**
   *
   * @param bulkUploadError
   * @returns {{type: *}}
   */
  bulkUploadSellersError = (bulkUploadError) => action(sellerActionTypes.BULK_UPLOAD_SELLER.ERROR, {
    bulkUploadError,
  })

   /**
   *
   * @param payload
   * @param callback
   * @returns {{type: *}}
   */
   bulkUpdateSellers = (payload, callback) => action(sellerActionTypes.BULK_UPDATE_SELLER.REQUEST, {
     payload, callback,
   })

  /**
   *
   * @param bulkUpdateSellersLoading
   * @returns {{type: *}}
   */
  bulkUpdateSellersLoading = (bulkUpdateSellersLoading) => action(sellerActionTypes.BULK_UPDATE_SELLER.LOADING, {
    bulkUpdateSellersLoading,
  })

  /**
   *
   * @param bulkUpdateResponse
   * @returns {{type: *}}
   */
  bulkUpdateSellersSuccess = (bulkUpdateResponse) => action(sellerActionTypes.BULK_UPDATE_SELLER.SUCCESS, {
    bulkUpdateResponse,
  })

  /**
   *
   * @param bulkUpdateError
   * @returns {{type: *}}
   */
  bulkUpdateSellersError = (bulkUpdateError) => action(sellerActionTypes.BULK_UPDATE_SELLER.ERROR, {
    bulkUpdateError,
  })

  getTallySellers = (itId, orgId, searchKeyword, callback, selectedSeller) => action(sellerActionTypes.GET_TALLY_SELLERS.REQUEST, {
    itId, orgId, searchKeyword, callback, selectedSeller
  })

  /**
   *
   * @param getTallySellersLoading
   * @return {{type: *}}
   */
  getTallySellersLoading = (getTallySellersLoading) => action(sellerActionTypes.GET_TALLY_SELLERS.LOADING, {
    getTallySellersLoading,
  })

  /**
   *
   * @param tallySellers
   * @return {{type: *}}
   */
  getTallySellersSuccess = (tallySellers) => action(sellerActionTypes.GET_TALLY_SELLERS.SUCCESS, {
    tallySellers,
  })
}
export default new SellerActions();
